import { createContext, useContext, useState, useCallback } from "react";
import { ServePrompt } from "@/components/ServePrompt";
import { ActionForm } from "@/components/ActionForm";

const VisitorContext = createContext(null);
const readProfile = () => JSON.parse(localStorage.getItem("vp_visitor") || "null");

export const VisitorProvider = ({ children }) => {
  const [intent, setIntentState] = useState(() => localStorage.getItem("vp_intent") || "");
  const [profile, setProfileState] = useState(readProfile);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState(null);

  const setIntent = useCallback((id) => {
    localStorage.setItem("vp_intent", id);
    setIntentState(id);
  }, []);

  const setProfile = useCallback((p) => {
    localStorage.setItem("vp_visitor", JSON.stringify(p));
    setProfileState(p);
  }, []);

  const openQuestionnaire = useCallback(() => {
    localStorage.setItem("vp_prompted", "1");
    setOpen(true);
  }, []);

  const openAction = useCallback((id, preset = {}) => setAction({ id, preset }), []);

  return (
    <VisitorContext.Provider value={{ intent, setIntent, profile, setProfile, openQuestionnaire, openAction, promptOpen: open }}>
      {children}
      <ServePrompt open={open} onOpenChange={setOpen} />
      <ActionForm state={action} onClose={() => setAction(null)} />
    </VisitorContext.Provider>
  );
};

export const useVisitor = () => useContext(VisitorContext);
